import { Datagrid, FunctionField, List, RichTextField, Show, SimpleShowLayout, TextField } from "react-admin";

export const ConsultationsList = (props) => {
  return (
    <List {...props}>
      <Datagrid rowClick={"show"}>
        <TextField source="type" />
        <FunctionField
          label="User Name"
          render={(record) => record.user ? record.user.name : 'No User'}
        />
         <FunctionField
          label="User Phone"
          render={(record) => record.user ? record.user.phonenumber : 'No User'}
        />
        <RichTextField source="description" />

        <FunctionField
          label="Created At"
          render={(record) =>
            `${new Date(record.created_at).toLocaleString()} `
          }
        />
      </Datagrid>
    </List>
  );
};

export const ConsultationShow = () => (
  <Show>
      <SimpleShowLayout>
      <TextField source="type" />
        <FunctionField
          label="User Name"
          render={(record) => record.user ? record.user.name : 'No User'}
        />
          <FunctionField
          label="User Phone"
          render={(record) => record.user ? record.user.phonenumber : 'No User'}
        />
        <RichTextField source="description" />

        <FunctionField
          label="Created At"
          render={(record) =>
            `${new Date(record.created_at).toLocaleString()} `
          }
        />
      </SimpleShowLayout>
  </Show>
);